import initLocalization from "$lib/services/localization";
import type { Unsubscriber } from 'svelte/store';

function run(): Unsubscriber {
	const cleanupLocalization = initLocalization();

	return () => {
		cleanupLocalization();
	};
}

export default run;
